var _defs, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 40 200 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-9{fill:#fff;}.cls-1{fill-rule:evenodd;}.cls-2{font-size:12px;font-family:SofiaPro-Bold, Sofia Pro;font-weight:700;}.cls-3{letter-spacing:-0.01em;}.cls-4{letter-spacing:0em;}.cls-5{letter-spacing:-0.02em;}.cls-6{letter-spacing:-0.01em;}.cls-7{letter-spacing:-0.01em;}.cls-8{letter-spacing:-0.03em;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(20.56 49.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3"
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.75,
    y: 0
  }, "mile "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 32.75,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.84,
    y: 0
  }, "imulation"), /*#__PURE__*/React.createElement("tspan", {
    x: 94,
    y: 0
  }, "Viewer"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsv);
export default __webpack_public_path__ + "static/media/SSV.90a198a7f920cbae08bb46ee13672e82.svg";
export { ForwardRef as ReactComponent };